import { DocumentReference, EntityOption } from '@context/shared/types/common';
import { Organization } from '../types';

export class OrganizationOption extends EntityOption<Organization> {
	logoUrl: string | null = null;

	constructor(
		data: Organization,
		ref?: DocumentReference<Organization> | null,
	) {
		super(data, ref);
		this.logoUrl = data.logoUrl ?? null;
	}

	protected override toString() {
		return this.data.name;
	}
}
